jQuery(document).ready(function () {

    $(document).on('click', '.dnJs-formSettingsAddAdditionalReceipts', function() {
        var button = $(this);
        var prototype = button.attr('data-prototype');
        var newForm = prototype.replace(/\$\$id\$\$/g, $('.dnJs-formSettingsAddAdditionalReceipts-container > .dnFormInputText').length);
        $('.dnJs-formSettingsAddAdditionalReceipts-container').append(newForm);
    });
});
